import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { Row } from "react-bootstrap";

import Icon from "./Icon";
import FilterSelect from "./FilterSelect";
import TableCalendarFilter from "./TableCalendarFilter";
import {
  sortItems,
  convertSortToText,
  userRoleItems,
  convertRoleToText,
  bulkSMSTypeItems,
  convertBulkSMSTypeToText,
} from "../utils/enum";
import { addAllItemToFilters } from "../utils";

const itemsCountItems = [10, 25, 50, 75, 100, 150, 200];

const TableFilter = ({
  setStart,
  start,
  setEnd,
  end,
  setItemsCount,
  itemsCount,
  setSort,
  sort,
  setRole,
  role,
  setIsActive,
  isActive,
  setIsConfirm,
  isConfirm,
  setIsSendSMS,
  isSendSMS,
  bulkSMSType,
  setBulkSMSType,
}) => {
  const { pathname } = useLocation();

  const [isShow, setIsShow] = useState(false);

  useEffect(() => {
    setIsShow(false);
  }, [pathname]);

  return (
    <div className="card mb-3">
      <div className="card-body position-relative card-tools-toggle">
        <div
          className="d-flex justify-content-between align-items-center"
          type="button"
          onClick={() => setIsShow(!isShow)}
        >
          <div>جستجو پیشرفته</div>
          <Icon
            icon={`eva:arrow-ios-${isShow ? "upward" : "downward"}-fill`}
            className="text-xxl"
          />
        </div>
        {isShow && (
          <>
            <hr className="mt-3" />
            <Row className="align-items-end">
              {setItemsCount && (
                <FilterSelect
                  title="تعداد"
                  items={itemsCountItems.map((item) => ({
                    label: item,
                    value: item,
                  }))}
                  value={itemsCount}
                  onChange={setItemsCount}
                />
              )}
              {setSort && (
                <FilterSelect
                  title="چیدمان"
                  items={addAllItemToFilters(
                    sortItems.map((item) => ({
                      label: convertSortToText(item),
                      value: item,
                    })),
                    "پیشفرض",
                  )}
                  value={sort}
                  onChange={setSort}
                />
              )}
              {setIsActive && (
                <FilterSelect
                  title="وضعیت"
                  items={addAllItemToFilters([
                    {
                      label: "فعال",
                      value: "true",
                    },
                    {
                      label: "غیرفعال",
                      value: "false",
                    },
                  ])}
                  value={isActive}
                  onChange={setIsActive}
                />
              )}
              {setIsConfirm && (
                <FilterSelect
                  title="وضعیت اطلاعات"
                  items={addAllItemToFilters([
                    {
                      label: "تایید شده",
                      value: "true",
                    },
                    {
                      label: "در انتظار تایید",
                      value: "false",
                    },
                  ])}
                  value={isConfirm}
                  onChange={setIsConfirm}
                />
              )}
              {setIsSendSMS && (
                <FilterSelect
                  title="وضعیت پیامک"
                  items={addAllItemToFilters([
                    {
                      label: "ارسال شده",
                      value: "true",
                    },
                    {
                      label: "ارسال نشده",
                      value: "false",
                    },
                  ])}
                  value={isSendSMS}
                  onChange={setIsSendSMS}
                />
              )}

              {setRole && (
                <FilterSelect
                  title="نقش کاربر"
                  items={addAllItemToFilters(
                    userRoleItems.map((item) => ({
                      label: convertRoleToText(item),
                      value: item,
                    })),
                    "همه",
                  )}
                  value={role}
                  onChange={setRole}
                />
              )}

              {setBulkSMSType && (
                <FilterSelect
                  title="نوع پیامک انبوه"
                  items={addAllItemToFilters(
                    bulkSMSTypeItems.map((item) => ({
                      label: convertBulkSMSTypeToText(item),
                      value: item,
                    })),
                    "همه",
                  )}
                  value={bulkSMSType}
                  onChange={setBulkSMSType}
                />
              )}
            </Row>
            {setStart && setEnd && (
              <Row className="align-items-end">
                <TableCalendarFilter
                  setStart={setStart}
                  start={start}
                  setEnd={setEnd}
                  end={end}
                />
              </Row>
            )}
          </>
        )}
      </div>
    </div>
  );
};

export default TableFilter;
